import BlogImage from "../../Assets/Images/Illustrations/why.png";
import Suresh from "../../Assets/Images/Company/suresh.png";
import WhyIPAgentAI from "../Blogs/WhyIPAgentAI";

export const Articles = {
    "why-ip-agent-ai-25ac8ad8-3449-4f4a-b538-b14502ae6720":{
        Title: "Why IP Agent AI?",
        Image: BlogImage,
        AuthorInfo: {
            Name: "Suresh Vallabhaneni",
            Title: "Founder & CEO",
            Image: Suresh,
            Company: {
                Name: "AnyGen AI",
                Link: "https://www.anygen.ai"
            }
        },
        PublishedDate: "February 7, 2025",
        Blog: WhyIPAgentAI,
        Preview: "A conversation with Donald, the Head of IP at a Fortune 100 company, revealed the deep inefficiencies in the IP industry, inspiring the creation of IP Agent AI, an agentic AI platform that automates routine tasks, allowing IP professionals to focus on higher-value intellectual work.",
    },
    // 2:{
    //     Title: "Blog 2",
    //     Image: BlogImage,
    //     Author: "Author 1",
    //     PublishedDate: "12/12/2024",
    //     Preview: "Lorem ipsum disp ak ldsfaj dslfjs kdfjlaskd fjklasdj flkjadskl fjaklsdfjaiesuri sdjfkljsd fkadsjflksd;jkursehthithiedshhtiehsht aiashdfka;ldkureshthatLorem ipsum disp ak ldsfaj dslfjs kdfjlaskd fjklasdj flkjadskl fjaklsdfjaiesuri sdjfkljsd fkadsjflksd;jkursehthithiedshhtiehsht aiashdfka;ldkureshthatLorem ipsum disp ak ldsfaj dslfjs kdfjlaskd fjklasdj flkjadskl fjaklsdfjaiesuri sdjfkljsd fkadsjflksd;jkursehthithiedshhtiehsht aiashdfka;ldkureshthat",
    // },
    // 3:{
    //     Title: "Blog 3",
    //     Image: BlogImage,
    //     Author: "Author 1",
    //     PublishedDate: "12/12/2024",
    //     Preview: "Lorem ipsum disp ak ldsfaj dslfjs kdfjlaskd fjklasdj flkjadskl fjaklsdfjaiesuri sdjfkljsd fkadsjflksd;jkursehthithiedshhtiehsht aiashdfka;ldkureshthatLorem ipsum disp ak ldsfaj dslfjs kdfjlaskd fjklasdj flkjadskl fjaklsdfjaiesuri sdjfkljsd fkadsjflksd;jkursehthithiedshhtiehsht aiashdfka;ldkureshthatLorem ipsum disp ak ldsfaj dslfjs kdfjlaskd fjklasdj flkjadskl fjaklsdfjaiesuri sdjfkljsd fkadsjflksd;jkursehthithiedshhtiehsht aiashdfka;ldkureshthat",
    // },
    // 4:{
    //     Title: "Blog 2",
    //     Image: BlogImage,
    //     Author: "Author 1",
    //     PublishedDate: "12/12/2024",
    //     Preview: "Lorem ipsum disp ak ldsfaj dslfjs kdfjlaskd fjklasdj flkjadskl fjaklsdfjaiesuri sdjfkljsd fkadsjflksd;jkursehthithiedshhtiehsht aiashdfka;ldkureshthatLorem ipsum disp ak ldsfaj dslfjs kdfjlaskd fjklasdj flkjadskl fjaklsdfjaiesuri sdjfkljsd fkadsjflksd;jkursehthithiedshhtiehsht aiashdfka;ldkureshthatLorem ipsum disp ak ldsfaj dslfjs kdfjlaskd fjklasdj flkjadskl fjaklsdfjaiesuri sdjfkljsd fkadsjflksd;jkursehthithiedshhtiehsht aiashdfka;ldkureshthat",
    // },
    // 5:{
    //     Title: "Blog 3",
    //     Image: BlogImage,
    //     Author: "Author 1",
    //     PublishedDate: "12/12/2024",
    //     Preview: "Lorem ipsum disp ak ldsfaj dslfjs kdfjlaskd fjklasdj flkjadskl fjaklsdfjaiesuri sdjfkljsd fkadsjflksd;jkursehthithiedshhtiehsht aiashdfka;ldkureshthatLorem ipsum disp ak ldsfaj dslfjs kdfjlaskd fjklasdj flkjadskl fjaklsdfjaiesuri sdjfkljsd fkadsjflksd;jkursehthithiedshhtiehsht aiashdfka;ldkureshthatLorem ipsum disp ak ldsfaj dslfjs kdfjlaskd fjklasdj flkjadskl fjaklsdfjaiesuri sdjfkljsd fkadsjflksd;jkursehthithiedshhtiehsht aiashdfka;ldkureshthat",
    // },
}